{
  "title": "Édition du profil",
  "subtitle": "Gérez vos informations personnelles, votre mot de passe et vos collaborateurs.",
  "tabs": {
    "personalInformation": "Informations personnelles",
    "password": "Mot de passe",
    "collaborators": "Collaborateurs"
  },
  "form": {
    "emailLogin": "Email de connexion",
    "phone": "Téléphone",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe"
  },
  "placeholders": {
    "phone": "Téléphone",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe"
  },
  "buttons": {
    "validate": "Valider",
    "validatePassword": "Valider le mot de passe",
    "updateCollaborator": "Modifier le collaborateur"
  },
  "table": {
    "lastname": "Nom",
    "firstname": "Prénom",
    "status": "Statut"
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente",
    "deleted": "Supprimé"
  },
  "searchCollaborators": "Rechercher un collaborateur",
  "statusFilter": "Statut",
  "messages": {
    "success": "Profil mis à jour"
  }
}
